/*
 * The Private License
 *
 * Copyright (c) 2023 Mahon Media LLC.
 */

export const createCsv = (arr) => {
  const csvRows = [];

  if (arr.length === 0) {
    return "";
  }

  // const mostHeaders = arr.reduce((maxIndex, object, currentIndex) => {
  //   const currentKeysCount = Object.keys(object).length;
  //   if (currentKeysCount > Object.keys(arr[maxIndex]).length) {
  //     return currentIndex;
  //   }
  //   return maxIndex;
  // }, 0);

  // const headers = Object.keys(arr[mostHeaders]);

  const headers = [
    "name",
    "surname",
    "email",
    "roomType",
    "ratePlanCode",
    "rateAmount",
    "checkIn",
    "checkOut",
    "bookingChannelCode"
  ];

  const filteredHeaders = headers.filter((header) => header !== "rid");

  const readableHeaders = headers.map((header) => fromCamelCase(header));

  csvRows.push(readableHeaders.join(","));

  arr.forEach((obj) => {
    const values = headers.map((header) => obj[header]).join(",");
    csvRows.push(values);
  });

  return csvRows.join("\n");
};

export const fromCamelCase = (str) =>
  str
    .replace(/([a-z\d])([A-Z])/g, "$1" + " " + "$2")
    .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, "$1" + " " + "$2")
    .toLowerCase();

/** iterate over array and find codes to render in filter dropdown
 * Returns an array of unique booking channel codes
 * @customers {array} - array of customers recieved from server
 */
export const createUniqueCodeItems = (customers) => {
  const uniqueCodes = [];

  customers.forEach((c) => {
    if (!uniqueCodes.includes(c.bookingChannelCode || "None"))
      uniqueCodes.push(c.bookingChannelCode || "None");
  });

  return uniqueCodes;
};
